// Restaurant footer: the shared footer (which owns all runtime brand / outlet
// contact data), dressed in the editorial skin via the `rx-footer` wrapper.
import FooterCommon from './FooterCommon.jsx';

export default function FooterRestaurant() {
  return (
    <div className="rx-footer">
      <FooterCommon />
    </div>
  );
}
